<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<div class="figure">
<img alt="Photograph of the author by Chloé Liradelfo." class="img-centre" src="Images/file0.png" style="width:2.28637in"/>
<p class="caption">Photograph of the author by Chloé Liradelfo.</p>
</div>
<p>Jay Conrad (<em>b</em>. Netherlands, 1955) has worked in London, the former West Berlin, Barcelona and Amsterdam as bartender, pizza cook, night watchman, musician and book trader. He described his experiences in the short story section of <em>NRC Handelsblad</em>, the daily newspaper published in Rotterdam. Nowadays, Conrad, a singer-songwriter and self-taught Hispanist, lives in Brussels.</p>
<p><em>Mirror City</em> is his first novel.</p>
<p>As a singer-songwriter, Conrad released two albums (<em>A Penniless Gentleman</em> and <em>Steeltown Girls</em>), to be followed, in early 2019, by <em>Carrizo Springs</em> (in Spanish, with lyrics of the poetess Raquel Lanseros) and <em>The North London Line</em> (autumn, 2019).</p>
<p>The Right Panel of the Sombrayagua Diptych ­– The Lens of Ibn Sahl is being written.</p>
<p>Cover illustration by Julie Sobotik.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4190cd64